import React, { createContext, useState, useContext, useCallback, useRef } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [userRole, setUserRole] = useState(null);
  const [verifiedToken, setVerifiedToken] = useState(null);
  const isVerifying = useRef(false);

  const verifyToken = useCallback(async (token) => {
    if (verifiedToken === token || isVerifying.current) {
      console.log('Skipping verifyToken: already verified or in progress');
      return;
    }
    isVerifying.current = true;
    try {
      console.log('Sending request to verify token:', token);
      const response = await fetch('http://localhost:8000/api/verify-token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      console.log('Response status:', response.status);
      if (!response.ok) {
        if (response.status === 429) {
          console.error('Rate limit exceeded. Please try again later.');
          return;
        }
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error('Response is not JSON');
      }
      const data = await response.json();
      console.log('Response data:', data);
      if (data.role !== userRole || verifiedToken !== token) {
        setUserRole(data.role);
        setVerifiedToken(token);
        console.log('Role set:', data.role);
      }
    } catch (error) {
      console.error('Error verifying token:', error.message, error);
      // window.location.href = 'http://localhost:3000?error=network_error';
    } finally {
      isVerifying.current = false;
    }
  }, [userRole, verifiedToken]);

  return (
    <AuthContext.Provider value={{ userRole, setUserRole, verifyToken, verifiedToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}